import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { SalesTeamLevel, SalesTeamNode } from '../../sales-team-management.model';
import { initialsOf, SALES_TEAM_LEVEL_BADGE, salesTeamLevel } from '../../sales-team-management.util';

/**
 * Confirms putting someone back under Admin. Closes with true on confirm; the page makes the request.
 * Removing an ASM's manager does not move their Sales Officers, so the dialog says so.
 */
@Component({
  selector: 'app-remove-manager-modal',
  standalone: false,
  templateUrl: './remove-manager-modal.component.html',
  styleUrl: './remove-manager-modal.component.scss',
})
export class RemoveManagerModalComponent {
  /** Set by the opener before the first render. */
  employee!: SalesTeamNode;
  managerName: string = '';

  constructor(protected activeModal: NgbActiveModal) {}

  /** "Amol Shinde's 3 Sales Officers will stay under them.", or empty when nobody reports to them. */
  get staysNote(): string {
    const count = this.employee.reports.length;

    if (salesTeamLevel(this.employee.designation) !== SalesTeamLevel.ASM || count === 0) {
      return '';
    }

    return `${this.employee.name}'s ${count} ${count === 1 ? 'Sales Officer' : 'Sales Officers'} will stay under them.`;
  }

  protected get initials(): string {
    return initialsOf(this.employee.name);
  }

  protected get levelClass(): string {
    return `level-${salesTeamLevel(this.employee.designation) ?? 'other'}`;
  }

  protected get badgeClass(): string {
    const level = salesTeamLevel(this.employee.designation);

    return level ? SALES_TEAM_LEVEL_BADGE[level].badgeClass : 'badge-soft-secondary';
  }
}
